export enum OcpsPolicyFeature {
    ShowAutoCompleteList = "showAutoCompleteList",
    Privacy = "privacy",
    UnifiedInbox = "unifiedInbox",
    KeyboardStyles = "keyboardStyles",
    AlwaysShowBcc = "alwaysShowBcc",
    Presence = "presence",
    Notifications = "notifications"
}

export enum ShowAutoCompleteListPolicySettingId {
    ShowAutoCompleteListUserOverride = "outlooknew;L_ShowAutoCompleteList;L_ShowAutoCompleteListUserOverride",
    ShowAutoCompleteListOptions = "outlooknew;L_ShowAutoCompleteList;L_ShowAutoCompleteListOptions"
}

export enum PrivacyPolicySettingId {
    OptionalConnectedExperiences = "office16;L_OptionalConnectedExperiences",
    ConnectedOfficeExperiences = "office16;L_ConnectedOfficeExperiences",
    // Beware of the typo "Anlayzing" — this is how the server stores it
    OfficeExperiencesAnalyzingContent = "office16;L_OfficeExperiencesAnlayzingContent",
    OfficeExperiencesDownloadingContent = "office16;L_OfficeExperiencesDownloadingContent"
}

export enum UnifiedInboxPolicySettingId {
    ShowAllAccountsView = "outlooknew;L_ShowAllAccountsView;L_ShowAllAccountsView",
    ShowAllAccountsViewUserOverride = "outlooknew;L_ShowAllAccountsView;L_ShowAllAccountsViewUserOverride"
}

export enum KeyboardStylesPolicySettingId {
    EnableKeytips = "outlooknew;L_KeyboardStyles;L_EnableKeytips",
    OutlookWebKeyboardShortcutStyle = "outlooknew;L_KeyboardStyles;L_WebKeyboardShortcutStyle",
    OutlookWindowsKeyboardShortcutStyle = "outlooknew;L_KeyboardStyles;L_WindowsKeyboardShortcutStyle",
    KeyboardStylesUserOverride = "outlooknew;L_KeyboardStyles;L_KeyboardStylesUserOverride"
}

export enum AlwaysShowBccPolicySettingId {
    AlwaysShowBccOptions = "outlooknew;L_AlwaysShowBcc;L_AlwaysShowBccOptions",
    AlwaysShowBccUserOverride = "outlooknew;L_AlwaysShowBcc;L_AlwaysShowBccUserOverride"
}

export enum PresencePolicySettingId {
    TurnOffPresenceIntegration = "office16;L_TurnOffPresenceIntegration",
    ConfigurePresenceIcons = "office16;L_ConfigurePresenceIcons;L_ConfigurePresenceIconsDropID"
}

export enum NotificationsPolicySettingId {
    GetNotifications = "outlooknew;L_NotificationSettings;L_GetNotifications",
    DocumentNotifications = "outlooknew;L_NotificationSettings;L_DocumentNotifications",
    ShowDocumentNotificationsInPane = "outlooknew;L_NotificationSettings;L_ShowDocumentNotificationsInPane",
    NotificationSettingsUserOverride = "outlooknew;L_NotificationSettings;L_NotificationSettingsUserOverride"
}

export type FeatureSettingIdMap = {
    [OcpsPolicyFeature.ShowAutoCompleteList]: ShowAutoCompleteListPolicySettingId;
    [OcpsPolicyFeature.Privacy]: PrivacyPolicySettingId;
    [OcpsPolicyFeature.UnifiedInbox]: UnifiedInboxPolicySettingId;
    [OcpsPolicyFeature.KeyboardStyles]: KeyboardStylesPolicySettingId;
    [OcpsPolicyFeature.AlwaysShowBcc]: AlwaysShowBccPolicySettingId;
    [OcpsPolicyFeature.Presence]: PresencePolicySettingId;
    [OcpsPolicyFeature.Notifications]: NotificationsPolicySettingId;
};

export type OutlookCloudPolicySettingId = FeatureSettingIdMap[OcpsPolicyFeature];

export const outlookCloudPolicySettingIdsByFeature: Readonly<Record<OcpsPolicyFeature, Readonly<Record<string, OutlookCloudPolicySettingId>>>> = {
    [OcpsPolicyFeature.ShowAutoCompleteList]: ShowAutoCompleteListPolicySettingId,
    [OcpsPolicyFeature.Privacy]: PrivacyPolicySettingId,
    [OcpsPolicyFeature.UnifiedInbox]: UnifiedInboxPolicySettingId,
    [OcpsPolicyFeature.KeyboardStyles]: KeyboardStylesPolicySettingId,
    [OcpsPolicyFeature.AlwaysShowBcc]: AlwaysShowBccPolicySettingId,
    [OcpsPolicyFeature.Presence]: PresencePolicySettingId,
    [OcpsPolicyFeature.Notifications]: NotificationsPolicySettingId,
};

export const FeatureToAllowUserOverrideSettingIdMap: Partial<Record<OcpsPolicyFeature, OutlookCloudPolicySettingId>> = {
    [OcpsPolicyFeature.ShowAutoCompleteList]: ShowAutoCompleteListPolicySettingId.ShowAutoCompleteListUserOverride,
    [OcpsPolicyFeature.UnifiedInbox]: UnifiedInboxPolicySettingId.ShowAllAccountsViewUserOverride,
    [OcpsPolicyFeature.KeyboardStyles]: KeyboardStylesPolicySettingId.KeyboardStylesUserOverride,
    [OcpsPolicyFeature.AlwaysShowBcc]: AlwaysShowBccPolicySettingId.AlwaysShowBccUserOverride,
    [OcpsPolicyFeature.Notifications]: NotificationsPolicySettingId.NotificationSettingsUserOverride,
};
